/**
 * @name InfoMessage
 * @description Componente para mostrar icono y mensaje de información
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, Unicons, Theme } from '@styles';

const InfoMessage = ({ message }) => {
  return (
    <Flex.Row flex="100%">
      <Styled.BoxIcon>
        <Unicons.CircleInfo size="20" color={Theme.colors.greyDark} />
      </Styled.BoxIcon>
      {message}
    </Flex.Row>
  );
};

InfoMessage.propTypes = {
  // Mensaje que se muestra dentro del componente.
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  margin-right: 8px;
`;

export default InfoMessage;